import { defineMessages } from 'react-intl';

export default defineMessages({
  translations: 'Translations',
  design: 'Design',
  addDistribution: 'Add distribution',
  addNewSurveyWithAnotherLanguage: 'Add new survey with another language',

  createSurvey: 'Create Survey',
  manageTranslations: 'Manage translations',
  addTranslation: 'New translation',
  addTranslationCopy: 'Create a copy in a new language',
});
